import request from "@/utils/axios";

//百度翻译用
export function getBaiDu(params) {
  return request({
    baseURL: "/",
    url: "/api/admin",
    method: "GET",
    params
  });
}

export function postsetlang(data) {
  return request({
    baseURL: "http://127.0.0.1:6500",
    url: "/setlang",
    method: "POST",
    data
  });
}

export function getsetlang(data) {
  return request({
    url: "/setlang",
    method: "GET",
    data
  });
}

export function getCanList(params) {
  return request({
    url: "api/admin/Case/getGoodsList",
    method: "GET",
    params
  });
}

//地区列表
export function getDistrictList(params) {
  return request({
    url: "api/common/getDistrictList",
    method: "GET",
    params
  });
}

//add餐厅
export function postRestaurant(data) {
  return request({
    url: "api/admin/restaurant/v1/save",
    method: "POST",
    data
  });
}
//add餐厅
export function postaddSalaryTask(data) {
  return request({
    url: "api/admin/googleSheets/v1/addSalaryTask",
    method: "POST",
    data
  });
}
//餐厅列表
export function getRestaurantList(params) {
  return request({
    url: "api/admin/restaurant/v1/list",
    method: "GET",
    params
  });
}
//导出离职
export function getresignEmployeetexport(params) {
  return request({
    url: "api/admin/resignEmployee/v1/export",
    method: "GET",
    params
  });
} //导出获取员工列表
export function getresignmobileUserexport(params) {
  return request({
    url: "api/admin/mobileUser/v1/export",
    method: "GET",
    params
  });
}
export function showPhone(params) {
  return request({
    url: "/api/admin/mobileUser/v1/showPhone",
    method: "GET",
    params
  });
}
//员工评价列表
export function getCommentEmployee(params) {
  return request({
    url: "api/admin/merchant/getCommentEmployee",
    method: "GET",
    params
  });
}
//餐厅列表详情
export function getRestaurantDetail(params) {
  return request({
    url: "api/admin/restaurant/v1/detail",
    method: "GET",
    params
  });
}

//删除餐厅
export function deleteRestaurant(id, params) {
  return request({
    url: `api/admin/restaurant/v1/delete?id=${id}`,
    method: "DELETE",
    params
  });
}

// 菜单列表
export function getSystemMenuList(params) {
  return request({
    url: "api/admin/systemMenu/v1/list",
    method: "GET",
    params
  });
}

// 菜单列表分组
export function getSystemMenuListData(params) {
  return request({
    url: "api/admin/systemMenu/v1/getSystemMenuList",
    method: "GET",
    params
  });
}

// 菜单列表新增
export function postSystemMenu(data) {
  return request({
    url: "api/admin/systemMenu/v1/save",
    method: "POST",
    data
  });
}

// 菜单列表新增
export function editMerchantUserListByGroup(data) {
  return request({
    url: "api/admin/merchant/editMerchantUserListByGroup",
    method: "POST",
    data
  });
}
// 菜单列表新增
export function postsetMerchantReferral(data) {
  return request({
    url: "api/admin/merchant/setMerchantReferral",
    method: "POST",
    data
  });
}

//删除餐厅
export function deleteSystemMenu(id, params) {
  return request({
    url: `api/admin/systemMenu/v1/delete?id=${id}`,
    method: "DELETE",
    params
  });
}

//角色列表
export function getRoleist(params) {
  return request({
    url: "api/admin/role/v1/list",
    method: "GET",
    params
  });
}
//协助列表
export function getSupportRecordList(params) {
  return request({
    url: "api/admin/user/getSupportRecordList",
    method: "GET",
    params
  });
}
//用户列表
export function getMerchantUserListByGroup(params) {
  return request({
    url: "api/admin/merchant/getMerchantUserListByGroup",
    method: "GET",
    params
  });
}
//用户列表
export function getgetReferralList(params) {
  return request({
    url: "/api/admin/merchant/getReferralList",
    method: "GET",
    params
  });
}
//用户列表
export function getDetailsWithSchedules(params) {
  return request({
    url: "api/admin/merchant/getDetailsWithSchedules",
    method: "GET",
    params
  });
}
//统计协助列表
export function getSupportStatistics(params) {
  return request({
    url: "api/admin/user/getSupportStatistics",
    method: "GET",
    params
  });
}
// 角色列表新增
export function postRolesave(data) {
  return request({
    url: "api/admin/role/v1/save",
    method: "POST",
    data
  });
}

//角色列表详情
export function getRoledetail(params) {
  return request({
    url: "api/admin/role/v1/detail",
    method: "GET",
    params
  });
}

//删除餐厅
export function deleteRole(id, params) {
  return request({
    url: `api/admin/role/v1/delete?id=${id}`,
    method: "DELETE",
    params
  });
}
//删除餐厅
export function deleteReferral(id, params) {
  return request({
    url: `api/admin/merchant/deleteReferral?id=${id}`,
    method: "POST",
    params
  });
}
//删除餐厅
export function deleteReferrer(id, params) {
  return request({
    url: `api/admin/merchant/deleteReferrer?id=${id}`,
    method: "POST",
    params
  });
}
//用户列表
export function getUserList(params) {
  return request({
    url: "api/admin/user/getUsers",
    method: "GET",
    params
  });
}
// 删除用户
export function deleteUser(id, params) {
  return request({
    url: `api/admin/user/deleteUser?id=${id}`,
    method: "POST",
    params
  });
}

// 删除用户
export function deleteUsertwo(id, params) {
  return request({
    url: `api/admin/mobileUser/v1/deleteUser?id=${id}`,
    method: "POST",
    params
  });
}

// 用户新增
export function postUser(data) {
  return request({
    url: "api/admin/register",
    method: "POST",
    data
  });
}

// 用户编辑
export function editUser(data) {
  return request({
    url: "api/admin/user/updateUser",
    method: "POST",
    data
  });
}

// 用户详情
export function getUserDetail(params) {
  return request({
    url: "api/admin/user/userInfo",
    method: "GET",
    params
  });
}
//登录
export function login(data) {
  return request({
    url: "api/admin/login",
    method: "post",
    data
  });
}
//退出登录
export function logout(data) {
  return request({
    url: "api/admin/logout",
    method: "post",
    data
  });
}

// 获取角色权限列表
export function getPermissionList(params) {
  return request({
    url: "api/admin/role/v1/getPermissionList",
    method: "GET",
    params
  });
}
// 获取角色权限列表
export function getRolePermissionList(params) {
  return request({
    url: "api/admin/role/v1/getRolePermissionList",
    method: "GET",
    params
  });
}

//add集团
export function postGroup(data) {
  return request({
    url: "api/admin/restaurantGroup/v1/save",
    method: "POST",
    data
  });
}

//集团列表
export function getGroupList(params) {
  return request({
    url: "api/admin/restaurantGroup/v1/list",
    method: "GET",
    params
  });
}
//集团列表
export function getSupervisorQuestionaire(params) {
  return request({
    url: "api/admin/supervisorQuestionaire/v1/list",
    method: "GET",
    params
  });
}
export function getSupervisorQuestionaireexport(params) {
  return request({
    url: "api/admin/supervisorQuestionaire/v1/export",
    method: "GET",
    params
  });
}
//集团列表
export function getmerchantGroupList(params) {
  return request({
    url: "api/admin/merchant/getGroupList",
    method: "GET",
    params
  });
}

//集团列表
export function getMerchantRelationshipAdminLog(params) {
  return request({
    url: "api/admin/merchant/getMerchantRelationshipAdminLog",
    method: "GET",
    params
  });
}

//集团列表详情
export function getGroupDetail(params) {
  return request({
    url: "api/admin/restaurantGroup/v1/detail",
    method: "GET",
    params
  });
}

//删除集团
export function deleteGroup(id, params) {
  return request({
    url: `api/admin/restaurantGroup/v1/delete?id=${id}`,
    method: "DELETE",
    params
  });
}

//员工列表
export function getEmployeeList(params) {
  return request({
    url: "api/admin/mobileUser/v1/list",
    method: "GET",
    params
  });
}

//离职员工列表
export function getresignEmployee(params) {
  return request({
    url: "api/admin/resignEmployee/v1/list",
    method: "GET",
    params
  });
}
// 删除员工
export function deleteEmployee(id, params) {
  return request({
    url: `api/admin/user/deleteUser?id=${id}`,
    method: "POST",
    params
  });
}
// 编辑问卷
export function supervisorQuestionaire(data) {
  return request({
    url: `api/admin/supervisorQuestionaire/v1/save`,
    method: "POST",
    data
  });
}
// 员工新增
export function postEmployee(data) {
  return request({
    url: "api/admin/mobileUser/v1/createUser",
    method: "POST",
    data
  });
}

// 离职员工修改
export function postresignEmployee(data) {
  return request({
    url: "api/admin/resignEmployee/v1/save",
    method: "POST",
    data
  });
}

// 员工编辑
export function editEmployee(data) {
  return request({
    url: "api/admin/mobileUser/v1/updateUser",
    method: "POST",
    data
  });
}

// 员工详情
export function getEmployeeDetail(params) {
  return request({
    url: "api/admin/mobileUser/v1/getDetail",
    method: "GET",
    params
  });
}
// 离职员工详情
export function getresignEmployeeDetail(params) {
  return request({
    url: "api/admin/resignEmployee/v1/detail",
    method: "GET",
    params
  });
}
// 打卡时间编辑
export function saveClock(data) {
  return request({
    url: "api/admin/clock/v1/save",
    method: "POST",
    data
  });
}

// 删除打卡时间
export function deleteClock(id, params) {
  return request({
    url: `api/admin/clock/v1/delete?id=${id}`,
    method: "DELETE",
    params
  });
}

// 审核列表
export function getauditList(params) {
  return request({
    url: "api/admin/mobileUser/v1/auditList",
    method: "GET",
    params
  });
}

// 审核员工
export function postMobileUser(data) {
  return request({
    url: "api/admin/mobileUser/v1/audit",
    method: "POST",
    data
  });
}

// 更新手机
export function clearPhoneId(data) {
  return request({
    url: "api/admin/mobileUser/v1/clearPhoneId",
    method: "POST",
    data
  });
}

// 新增颜色
export function colorSave(data) {
  return request({
    url: "api/admin/color/v1/save",
    method: "POST",
    data
  });
}
// 颜色列表
export function colorList(params) {
  return request({
    url: "api/admin/color/v1/list",
    method: "GET",
    params
  });
}
// 删除颜色
export function deleteClorr(id, params) {
  return request({
    url: `api/admin/color/v1/delete?id=${id}`,
    method: "DELETE",
    params
  });
}

//add通知
export function addNotice(data) {
  return request({
    url: "api/admin/notice/v1/save",
    method: "POST",
    data
  });
}

//通知列表
export function getNoticeList(params) {
  return request({
    url: "api/admin/notice/v1/list",
    method: "GET",
    params
  });
}

//通知列表
export function getEmployeeChangedLog(params) {
  return request({
    url: "api/admin/googleSheets/v1/employeeChangedLog",
    method: "GET",
    params
  });
}
// //通知列表详情
export function getNoticeDetail(params) {
  return request({
    url: "api/admin/notice/v1/detail",
    method: "GET",
    params
  });
}

// //删除通知
export function deleteNotice(id, params) {
  return request({
    url: `api/admin/notice/v1/delete?id=${id}`,
    method: "DELETE",
    params
  });
}

//留言类型列表
export function getMsgTypeList(params) {
  return request({
    url: "api/admin/messageType/v1/list",
    method: "GET",
    params
  });
}
// 新增编辑留言类型
export function postLeaveMsgType(data) {
  return request({
    url: "api/admin/messageType/v1/save",
    method: "POST",
    data
  });
}

// 获取留言类型详情
export function getMsgType(params) {
  return request({
    url: "api/admin/messageType/v1/detail",
    method: "GET",
    params
  });
}

//删除留言类型
export function deleteMsgType(id, params) {
  return request({
    url: `api/admin/messageType/v1/delete?id=${id}`,
    method: "DELETE",
    params
  });
}

//留言列表
export function getMessageList(params) {
  return request({
    url: "api/admin/message/v1/list",
    method: "GET",
    params
  });
}
// 导出留言
export function exportMessage(data) {
  return request({
    url: "api/admin/message/v1/export",
    method: "POST",
    data
  });
}

// 标记留言
export function handleMessage(data) {
  return request({
    url: "api/admin/message/v1/handle",
    method: "POST",
    data
  });
}

// 新增/修改餐厅员工

export function postSaveEmployee(data) {
  return request({
    url: "api/admin/workRule/v1/saveEmployee",
    method: "POST",
    data
  });
}

// 查询员工
export function getSchedule(params) {
  return request({
    url: "api/admin/workRule/v1/getSchedule",
    method: "GET",
    params
  });
}
// 新规则

export function postaddFixedWorkRule(data) {
  return request({
    url: "api/admin/workRule/v1/addFixedWorkRule",
    method: "POST",
    data
  });
}

//删除员工
export function deleteEmployeeworkRule(data) {
  return request({
    url: `api/admin/workRule/v1/deleteEmployee`,
    method: "DELETE",
    data
  });
}

// 查询排班规则
export function getEmployeeDetailworkRule(params) {
  return request({
    url: "api/admin/workRule/v1/getEmployeeDetail",
    method: "GET",
    params
  });
}

// 查询打卡标签
export function getworkTaglist(params) {
  return request({
    url: "api/admin/workTag/v1/list",
    method: "GET",
    params
  });
}

// 新规则

export function postsaveworkTag(data) {
  return request({
    url: "api/admin/workTag/v1/save",
    method: "POST",
    data
  });
}

// 查询打卡标签
export function getworkTagdetail(params) {
  return request({
    url: "api/admin/workTag/v1/detail",
    method: "GET",
    params
  });
}

//删除标签
export function deleteworkTag(id, data) {
  return request({
    url: `api/admin/workTag/v1/delete?id=${id}`,
    method: "DELETE",
    data
  });
}

// 餐厅新增用工人数

export function postrestaurantsavePeopleNum(data) {
  return request({
    url: "api/admin/restaurant/v1/savePeopleNum",
    method: "POST",
    data
  });
}
// 获取区域缺人概况
export function getSituation(params) {
  return request({
    url: "api/admin/workRule/v1/getSituation",
    method: "GET",
    params
  });
}

// 获取地区列表

export function getSdistricts(params) {
  return request({
    url: "api/admin/districts/v1/list",
    method: "GET",
    params
  });
}

// 新增地区列表

export function postSdistricts(data) {
  return request({
    url: "api/admin/districts/v1/save",
    method: "POST",
    data
  });
}

//删除地区
export function deleteSdistricts(id, data) {
  return request({
    url: `api/admin/districts/v1/delete?id=${id}`,
    method: "DELETE",
    data
  });
}
//删除离职
export function deleteadmincolor(id, data) {
  return request({
    url: `api/admin/color/v1/delete?id=${id}`,
    method: "DELETE",
    data
  });
}
// 地区详情

export function postSdistrictsdetail(params) {
  return request({
    url: "api/admin/districts/v1/detail",
    method: "GET",
    params
  });
}

// 提交留言
export function getUserDetail2(params) {
  return request({
    url: "api/admin/user/userDetail",
    method: "GET",
    params
  });
}
// 打卡记录
export function getworkClockIn(params) {
  return request({
    url: "api/admin/workClockIn/v1/list",
    method: "GET",
    params
  });
}

//打卡记录2
export function getworkworkRule(params) {
  return request({
    url: "api/admin/workRule/v1/list",
    method: "GET",
    params
  });
}

// 导出打卡记录
export function getworkClockInexport(params) {
  return request({
    url: "api/admin/workClockIn/v1/export",
    method: "GET",
    params
  });
}

// 导出打卡记录2
export function getworkworkRulenexport(params) {
  return request({
    url: "api/admin/workRule/v1/exportSchedule",
    method: "GET",
    params
  });
}
// 导出打卡记录2
export function exportReferrerDetails(params) {
  return request({
    url: "api/admin/merchant/exportReferrerDetails",
    method: "GET",
    params
  });
}
// 导出打卡记录2
export function exportAbsentEmployees(params) {
  return request({
    url: "/api/admin/googleSheets/v1/exportAbsentEmployees",
    method: "POST",
    params
  });
}
// 版本列表
export function getversionlist(params) {
  return request({
    url: "api/admin/version/v1/list",
    method: "GET",
    params
  });
}

// xinzneg版本列表
export function postversionsave(data) {
  return request({
    url: "api/admin/version/v1/save",
    method: "POST",
    data
  });
}

// xinzneg版本列表
export function restaurantsaveClocks(data) {
  return request({
    url: "api/admin/restaurant/v1/saveClocks",
    method: "POST",
    data
  });
}

// 调整餐厅用工人数
export function saveRestaurantRule(data) {
  return request({
    url: "api/admin/workRule/v1/saveRestaurantRule",
    method: "POST",
    data
  });
}

// 获取餐厅调整信息
export function getRestaurantSchedule(params) {
  return request({
    url: "api/admin/workRule/v1/getRestaurantSchedule",
    method: "GET",
    params
  });
}

//删除地区
export function deleteRestaurantRule(id, data) {
  return request({
    url: `api/admin/workRule/v1/deleteRestaurantRule?rule_id=${id}`,
    method: "DELETE",
    data
  });
}

// 获取餐厅调整信息
export function getRestaurantDetailrule(params) {
  return request({
    url: "api/admin/workRule/v1/getRestaurantDetail",
    method: "GET",
    params
  });
}

// 获取餐厅调整信息
export function exportSchedule(params) {
  return request({
    url: "api/admin/workRule/v1/exportSchedule",
    method: "GET",
    params
  });
}

// 获取餐厅调整信息
export function exportScheduleStatistic(params) {
  return request({
    url: "api/admin/workRule/v1/exportScheduleStatistic",
    method: "GET",
    params
  });
}

// 补卡
export function punchIndddul(data) {
  return request({
    url: "api/admin/workRule/v1/punchIn",
    method: "POST",
    data
  });
}

// 获取在线人数
export function getOnlineUsers(params) {
  return request({
    url: "api/admin/user/getOnlineUsers",
    method: "GET",
    params
  });
}

//客服列表
export function getcustomerService(params) {
  return request({
    url: "api/admin/customerService/v1/list",
    method: "GET",
    params
  });
}
// 新增编辑留言类型
export function updateOrCreateSchedule(data) {
  return request({
    url: "api/admin/customerService/v1/updateOrCreateSchedule",
    method: "POST",
    data
  });
}

// 新增编辑留言类型
export function postaddSchedule(data) {
  return request({
    url: "api/admin/customerService/v1/addSchedule",
    method: "POST",
    data
  });
}
//客服列表
export function getScheduleDetails(params) {
  return request({
    url: "api/admin/customerService/v1/list",
    method: "GET",
    params
  });
}
// 新增编辑留言类型
export function updateSchedule(data) {
  return request({
    url: "api/admin/customerService/v1/updateSchedule",
    method: "POST",
    data
  });
}
//删除客服排班
export function deleteSchedule(id, params) {
  return request({
    url: `api/admin/customerService/v1/deleteSchedule?id=${id}`,
    method: "DELETE",
    params
  });
}
// 新增编辑留言类型
export function saveFixedRestaurantRule(data) {
  return request({
    url: "api/admin/workRule/v1/saveFixedRestaurantRule",
    method: "POST",
    data
  });
}
// 新规则

export function editFixedWorkRule(data) {
  return request({
    url: "api/admin/workRule/v1/editFixedWorkRule",
    method: "POST",
    data
  });
}
// 设置员工休息排班

export function saveFixedRestRule(data) {
  return request({
    url: "api/admin/workRule/v1/saveFixedRestRule",
    method: "POST",
    data
  });
}
// 设置员工休息排班

export function saveSpecialWorkRule(data) {
  return request({
    url: "api/admin/workRule/v1/saveSpecialWorkRule",
    method: "POST",
    data
  });
}
// 设置员工特殊休息排班

export function saveSpecialRestRule(data) {
  return request({
    url: "api/admin/workRule/v1/saveSpecialRestRule",
    method: "POST",
    data
  });
}
//删除员工排班

export function deleteWorkRule(data) {
  return request({
    url: `api/admin/workRule/v1/deleteWorkRule`,
    method: "DELETE",
    data
  });
}
// 设置餐厅特殊用工规则
export function saveSpecialRestaurantRule(data) {
  return request({
    url: "api/admin/workRule/v1/saveSpecialRestaurantRule",
    method: "POST",
    data
  });
}

// 新增地区列表

export function toggleFixedUncertainRule(data) {
  return request({
    url: "api/admin/workRule/v1/toggleFixedUncertainRule",
    method: "POST",
    data
  });
}

// 设置员工特殊不确定状态

export function saveSpecialWorkUncertainRule(data) {
  return request({
    url: "api/admin/workRule/v1/saveSpecialWorkUncertainRule",
    method: "POST",
    data
  });
}

//删除员工不确定规则
export function deleteWorkUncertainRule(data) {
  return request({
    url: `api/admin/workRule/v1/deleteWorkUncertainRule`,
    method: "DELETE",
    data
  });
}

//查询员工单个排班规则

export function getWorkRuleDetail(params) {
  return request({
    url: "api/admin/workRule/v1/getWorkRuleDetail",
    method: "GET",
    params
  });
}
// 设置员工特殊不确定状态

export function saveRemark(data) {
  return request({
    url: "api/admin/restaurant/v1/remark",
    method: "POST",
    data
  });
}
//查询餐厅关联用工规则

export function getRestaurantLinkRules(params) {
  return request({
    url: "api/admin/workRule/v1/getRestaurantLinkRules",
    method: "GET",
    params
  });
}

/**跑场 */

// 获取区域缺人概况
export function getWorkWaitingSituation(params) {
  return request({
    url: "api/admin/workWaitingRule/v1/getSituation",
    method: "GET",
    params
  });
}
// 获取跑场排班信息

export function getWorkWaitingSchedule(params) {
  return request({
    url: "api/admin/workWaitingRule/v1/getSchedule",
    method: "GET",
    params
  });
}
// 新增
export function addFixedWorkWaitingRule(data) {
  return request({
    url: "api/admin/workWaitingRule/v1/addFixedWorkWaitingRule",
    method: "POST",
    data
  });
}

export function editFixedWorkWaitingRule(data) {
  return request({
    url: "api/admin/workWaitingRule/v1/editFixedWorkWaitingRule",
    method: "POST",
    data
  });
}

//获取跑场全部规则
export function getWorkWaitingEmployeeDetail(params) {
  return request({
    url: "api/admin/workWaitingRule/v1/getEmployeeDetail",
    method: "GET",
    params
  });
}

export function deleteWorkWaitingEmployee(data) {
  return request({
    url: `api/admin/workWaitingRule/v1/deleteEmployee`,
    method: "DELETE",
    data
  });
}
//查询跑场单个规则
export function getWorkWaitingRuleDetail(params) {
  return request({
    url: "api/admin/workWaitingRule/v1/getWorkWaitingRuleDetail",
    method: "GET",
    params
  });
}
// 设置跑场特殊规则

export function saveSpecialWorkWaitingRule(data) {
  return request({
    url: "api/admin/workWaitingRule/v1/saveSpecialWorkWaitingRule",
    method: "POST",
    data
  });
}

// 设置跑场休息规则
export function saveFixedRestWaitingRule(data) {
  return request({
    url: "api/admin/workWaitingRule/v1/saveFixedRestWaitingRule",
    method: "POST",
    data
  });
}
// 设置跑场休息规则
export function saveSpecialRestWaitingRule(data) {
  return request({
    url: `api/admin/workWaitingRule/v1/saveSpecialRestWaitingRule`,
    method: "POST",
    data
  });
}

// 设置跑场休息规则
export function temporaryAddress(data) {
  return request({
    url: `http://8.210.116.157:3000/api/error_log`,
    method: "POST",
    data
  });
}

export function deleteWorkWaitingRule(data) {
  return request({
    url: `api/admin/workWaitingRule/v1/deleteWorkWaitingRule`,
    method: "DELETE",
    data
  });
}

/** 不确定规则 切换 */
export function toggleFixedWaitingUncertainRule(data) {
  return request({
    url: `api/admin/workWaitingRule/v1/toggleFixedWaitingUncertainRule`,
    method: "POST",
    data
  });
}
/** 不确定规则  获取 */
export function getWorkWaitingUncertainRuleDetail(params) {
  return request({
    url: "api/admin/workWaitingRule/v1/getWorkWaitingUncertainRuleDetail",
    method: "GET",
    params
  });
}
/** 设置跑场特殊不确定状态 */
export function saveSpecialWorkWaitingUncertainRule(data) {
  return request({
    url: `api/admin/workWaitingRule/v1/saveSpecialWorkWaitingUncertainRule`,
    method: "POST",
    data
  });
}
/** 删除跑场不确定规则
 DELETE */
export function deleteWorkWaitingUncertainRule(data) {
  return request({
    url: `api/admin/workWaitingRule/v1/deleteWorkWaitingUncertainRule`,
    method: "DELETE",
    data
  });
}

/** 获取餐厅确认时间段 */
export function getLackClocks(params) {
  return request({
    url: "api/admin/workWaitingRule/v1/getLackClocks",
    method: "GET",
    params
  });
}
/** 获取区域每日备注 */
export function getDistrictRemarks(params) {
  return request({
    url: "api/admin/workRule/v1/getDistrictRemarks",
    method: "GET",
    params
  });
}
/** 设置地区某日备注 */
export function saveDistrictRemark(data) {
  return request({
    url: `api/admin/workRule/v1/saveDistrictRemark`,
    method: "POST",
    data
  });
}

/** 设置地区某日备注 */
export function saveWorkRule(data) {
  return request({
    url: `api/admin/workWaitingRule/v1/saveWorkRule`,
    method: "POST",
    data
  });
}

/** 设置地区某日备注 */
export function ossupload(data) {
  return request({
    url: `api/oss/upload`,
    method: "POST",
    data
  });
}
/** 获取餐厅确认时间段 */
export function getCronConfig(params) {
  return request({
    url: "api/admin/googleSheets/v1/getCronConfig",
    method: "GET",
    params
  });
}
/** 获取餐厅确认时间段 */
export function googleSheetslist(params) {
  return request({
    url: "api/admin/googleSheets/v1/list",
    method: "GET",
    params
  });
}
/** 获取餐厅确认时间段 */
export function getoperateLog(params) {
  return request({
    url: "api/admin/operateLog/list",
    method: "GET",
    params
  });
}
/** 查看导出任务 */
export function exportTaskList(params) {
  return request({
    url: "api/admin/googleSheets/v1/exportTaskList",
    method: "GET",
    params
  });
}
/** 导出更表明细 */
export function exportGoogleSheetSchedules(params) {
  return request({
    url: "api/admin/googleSheets/v1/exportGoogleSheetSchedules",
    method: "POST",
    params
  });
}
/** 获取餐厅确认时间段 */
export function salaryTaskList(params) {
  return request({
    url: "api/admin/googleSheets/v1/salaryTaskList",
    method: "GET",
    params
  });
}

// 出粮检查配置
export function getSalaryPaymentConfig(params) {
  return request({
    url: "api/admin/googleSheets/v1/salaryPayment/config",
    method: "GET",
    params
  });
}

export function saveSalaryPaymentConfig(data) {
  return request({
    url: "api/admin/googleSheets/v1/salaryPayment/config",
    method: "POST",
    data
  });
}

// 手动执行出粮检查
export function runSalaryPaymentCheck(data) {
  return request({
    url: "api/admin/googleSheets/v1/salaryPayment/run",
    method: "POST",
    data
  });
}

// 出粮检查批次
export function salaryPaymentRunList(params) {
  return request({
    url: "api/admin/googleSheets/v1/salaryPayment/runs",
    method: "GET",
    params
  });
}

export function salaryPaymentRunDetail(id) {
  return request({
    url: `api/admin/googleSheets/v1/salaryPayment/runs/${id}`,
    method: "GET"
  });
}

// 出粮检查问题
export function salaryPaymentIssueList(params) {
  return request({
    url: "api/admin/googleSheets/v1/salaryPayment/issues",
    method: "GET",
    params
  });
}

export function updateSalaryPaymentIssueStatus(id, data) {
  return request({
    url: `api/admin/googleSheets/v1/salaryPayment/issues/${id}/status`,
    method: "POST",
    data
  });
}

// 出粮检查扫表明细
export function salaryPaymentRowList(params) {
  return request({
    url: "api/admin/googleSheets/v1/salaryPayment/rows",
    method: "GET",
    params
  });
}

// 工资表工具
export function protectSalarySheetRows(data) {
  return request({
    url: "api/admin/googleSheets/v1/protectSalarySheetRows",
    method: "POST",
    data
  });
}

export function deleteSalarySheetRowsProtection(data) {
  return request({
    url: "api/admin/googleSheets/v1/deleteSalarySheetRowsProtection",
    method: "POST",
    data
  });
}

export function recordSalaryFColumnChanges(data) {
  return request({
    url: "api/admin/googleSheets/v1/recordSalaryFColumnChanges",
    method: "POST",
    data
  });
}

export function transferSalaryOutItems(data) {
  return request({
    url: "api/admin/googleSheets/v1/transferSalaryOutItems",
    method: "POST",
    data
  });
}

export function insertSalaryCashItems(data) {
  return request({
    url: "api/admin/googleSheets/v1/insertSalaryCashItems",
    method: "POST",
    data
  });
}

export function insertSalaryChequeItems(data) {
  return request({
    url: "api/admin/googleSheets/v1/insertSalaryChequeItems",
    method: "POST",
    data
  });
}

export function runSalaryMaintenance(data) {
  return request({
    url: "api/admin/googleSheets/v1/runSalaryMaintenance",
    method: "POST",
    data
  });
}
/** 设置地区某日备注 */
export function googleSheetssetCronConfig(data) {
  return request({
    url: `api/admin/googleSheets/v1/setCronConfig`,
    method: "POST",
    data
  });
}
/** 上传图片 */
export function uploadoop(data) {
  return request({
    url: `api/oss/upload`,
    method: "POST",
    data
  });
}

// 导出加班餐厅打卡
export function exportOvertimeClockRestaurants(params) {
  return request({
    url: "api/admin/googleSheets/v1/exportOvertimeClockRestaurants",
    method: "POST",
    params
  });
}

export function exportRestaurantExpense(data) {
  return request({
    url: "api/admin/workRule/v1/exportRestaurantExpense",
    method: "POST",
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

// 商户列表
export function getMerchantList(params) {
  return request({
    url: "api/admin/merchant/list",
    method: "GET",
    params
  });
}

// 商户详情
export function getMerchantDetail(params) {
  return request({
    url: "api/admin/merchant/detail",
    method: "GET",
    params
  });
}

// 商户保存（新增/编辑）
export function saveMerchant(data) {
  return request({
    url: "api/admin/merchant/save",
    method: "POST",
    data
  });
}

// 检查手机号是否存在
export function checkMerchantPhone(params) {
  return request({
    url: "api/admin/merchant/checkPhone",
    method: "GET",
    params
  });
}

// 商户餐厅权限
export function getRestaurantPermissions(params) {
  return request({
    url: "api/admin/merchant/getRestaurantPermissions",
    method: "GET",
    params
  });
}




// WEBPACK FOOTER //
// ./src/utils/api/common.js